import { Component, Input, OnInit } from '@angular/core';
import {
  FileDownloadControlDto,
  FileDto,
} from 'src/app/data/models/dto/file.dto';
import { News } from 'src/app/data/models/interfaces/news';

@Component({
  selector: 'app-news-info',
  templateUrl: './news-info.component.html',
  styleUrls: ['./news-info.component.scss'],
})
export class NewsInfoComponent implements OnInit {
  @Input() news: News | undefined;
  attachmentText = 'Nenhum item anexado';
  attachmentsPath = '';
  downloadFilesControl: FileDownloadControlDto[] = [];

  constructor() { }

  async ngOnInit(): Promise<void> {
    if (this.news && this.news.files) {
      if (this.news.files.length == 1) {
        this.attachmentText = '1 item anexado';
      } else if (this.news.files.length > 1) {
        this.attachmentText = `${this.news.files.length} itens anexados`;
      }
      if (
        this.news.files &&
        this.news.files.length > 0 &&
        typeof this.news.files[0] === 'string'
      )
        this.attachmentsPath = `news/${this.news.id}`;

      if (this.attachmentsPath == '') this.initArraysNewStructure();
      else this.initArraysOldStructure();
    }
  }

  private initArraysNewStructure() {
    const newStructureFiles = this.news?.files as FileDto[];
    this.downloadFilesControl = newStructureFiles.map((file) => {
      return new FileDownloadControlDto(
        file.id,
        file.bucketKey,
        file.path,
        file.name,
        false
      );
    });
  }
  private initArraysOldStructure() {
    const oldStructureFiles = this.news?.files as string[];
    this.downloadFilesControl = oldStructureFiles.map((file) => {
      return new FileDownloadControlDto(
        '',
        '',
        this.attachmentsPath,
        file,
        false
      );
    });
  }
}
